module.exports = __webpack_public_path__ + "static/bg-a9e7ef8978cf43a1c816b818a13f0c4a.png";